import { useState } from "react";
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useDeleteFaq = () => {
  const [faqId, setFaqId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer } = useCreate({
    url: 'faqs/delete',
    refreshUrl: 'faqs/list',
    onSuccess: () => {
      toast.success("FAQ Deleted Successfully", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    },
    onError: (error) => {
    const apiMessage = error?.response?.data?.message;
    toast.error(apiMessage || "Error Deleting FAQ", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return {
    faqId,
    setFaqId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteFaq;
